/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input } from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";

/**
 * Component that displays form control errors.
 *
 * Usage:
 *
 */
@Component({
    selector: "form-errors",
    templateUrl: "./form-errors.component.html",
})
export class FormErrorsComponent implements ControlValueAccessor {
    @Input() key = "required";

    constructor(public formControl: NgControl) {
        formControl.valueAccessor = this;
    }

    /**
     * Fake implementation of ControlValueAccessor to retrieve the form control errors.
     */
    writeValue(_obj: any): void {
        return;
    }
    registerOnChange(_fn: any): void {
        return;
    }
    registerOnTouched(_fn: any): void {
        return;
    }
    setDisabledState?(_isDisabled: boolean): void {
        return;
    }
}
